<tf-checkbox
            [(ngModel)]="checked"
            [ngbPopover]="popoverWarningTemplate(popContentMessage, popContentWarning)"
            placement="left auto"
            triggers="manual"
            #p="ngbPopover"
            popoverClass="popover-message-layout tf-ngb-popover"
            [autoClose]="true"
            (onClick)="handleCheckChange($event, p)">
</tf-checkbox>

<ng-template #popContentMessage>
    <div class="popover-text">
        <span>Select products to compare, add to cart, export, or email from the toolbar below.</span>
    </div>
</ng-template>
<ng-template #popContentWarning>
    <div class="popover-text">
        Note: Only 3 items can be compared at a time.
    </div>
</ng-template>
